// Curated dial-code list — popular countries first, then alphabetised.
// Each entry is { code: ISO-3166-1 alpha-2, dial: '+XX', label, flag }.
// Flag is a Unicode regional-indicator pair so it renders as the country
// flag on any platform that supports emoji (all modern browsers + iOS/Android).
//
// We deliberately keep this list small (~55 entries) instead of importing
// a 200KB dial-code lib. If a user needs a country not listed, the Phone
// input is still a free-form `<input>` and the backend libphonenumber
// validator handles every region on Earth.
export const COUNTRY_DIAL_CODES = [
  // --- Top tier: highest signup volume markets ---
  { code: 'US', dial: '+1',   label: 'United States',  flag: '🇺🇸' },
  { code: 'PH', dial: '+63',  label: 'Philippines',    flag: '🇵🇭' },
  { code: 'GB', dial: '+44',  label: 'United Kingdom', flag: '🇬🇧' },
  { code: 'CA', dial: '+1',   label: 'Canada',         flag: '🇨🇦' },
  { code: 'AU', dial: '+61',  label: 'Australia',      flag: '🇦🇺' },
  { code: 'IN', dial: '+91',  label: 'India',          flag: '🇮🇳' },

  // --- Rest, alphabetised by country name ---
  { code: 'AR', dial: '+54',  label: 'Argentina',      flag: '🇦🇷' },
  { code: 'AT', dial: '+43',  label: 'Austria',        flag: '🇦🇹' },
  { code: 'BD', dial: '+880', label: 'Bangladesh',     flag: '🇧🇩' },
  { code: 'BE', dial: '+32',  label: 'Belgium',        flag: '🇧🇪' },
  { code: 'BR', dial: '+55',  label: 'Brazil',         flag: '🇧🇷' },
  { code: 'CH', dial: '+41',  label: 'Switzerland',    flag: '🇨🇭' },
  { code: 'CL', dial: '+56',  label: 'Chile',          flag: '🇨🇱' },
  { code: 'CN', dial: '+86',  label: 'China',          flag: '🇨🇳' },
  { code: 'CO', dial: '+57',  label: 'Colombia',       flag: '🇨🇴' },
  { code: 'CZ', dial: '+420', label: 'Czechia',        flag: '🇨🇿' },
  { code: 'DE', dial: '+49',  label: 'Germany',        flag: '🇩🇪' },
  { code: 'DK', dial: '+45',  label: 'Denmark',        flag: '🇩🇰' },
  { code: 'EG', dial: '+20',  label: 'Egypt',          flag: '🇪🇬' },
  { code: 'ES', dial: '+34',  label: 'Spain',          flag: '🇪🇸' },
  { code: 'FI', dial: '+358', label: 'Finland',        flag: '🇫🇮' },
  { code: 'FR', dial: '+33',  label: 'France',         flag: '🇫🇷' },
  { code: 'GR', dial: '+30',  label: 'Greece',         flag: '🇬🇷' },
  { code: 'HK', dial: '+852', label: 'Hong Kong',      flag: '🇭🇰' },
  { code: 'HU', dial: '+36',  label: 'Hungary',        flag: '🇭🇺' },
  { code: 'ID', dial: '+62',  label: 'Indonesia',      flag: '🇮🇩' },
  { code: 'IE', dial: '+353', label: 'Ireland',        flag: '🇮🇪' },
  { code: 'IL', dial: '+972', label: 'Israel',         flag: '🇮🇱' },
  { code: 'IT', dial: '+39',  label: 'Italy',          flag: '🇮🇹' },
  { code: 'JP', dial: '+81',  label: 'Japan',          flag: '🇯🇵' },
  { code: 'KE', dial: '+254', label: 'Kenya',          flag: '🇰🇪' },
  { code: 'KR', dial: '+82',  label: 'South Korea',    flag: '🇰🇷' },
  { code: 'MA', dial: '+212', label: 'Morocco',        flag: '🇲🇦' },
  { code: 'MX', dial: '+52',  label: 'Mexico',         flag: '🇲🇽' },
  { code: 'MY', dial: '+60',  label: 'Malaysia',       flag: '🇲🇾' },
  { code: 'NG', dial: '+234', label: 'Nigeria',        flag: '🇳🇬' },
  { code: 'NL', dial: '+31',  label: 'Netherlands',    flag: '🇳🇱' },
  { code: 'NO', dial: '+47',  label: 'Norway',         flag: '🇳🇴' },
  { code: 'NZ', dial: '+64',  label: 'New Zealand',    flag: '🇳🇿' },
  { code: 'PE', dial: '+51',  label: 'Peru',           flag: '🇵🇪' },
  { code: 'PK', dial: '+92',  label: 'Pakistan',       flag: '🇵🇰' },
  { code: 'PL', dial: '+48',  label: 'Poland',         flag: '🇵🇱' },
  { code: 'PT', dial: '+351', label: 'Portugal',       flag: '🇵🇹' },
  { code: 'RO', dial: '+40',  label: 'Romania',        flag: '🇷🇴' },
  { code: 'RU', dial: '+7',   label: 'Russia',         flag: '🇷🇺' },
  { code: 'SA', dial: '+966', label: 'Saudi Arabia',   flag: '🇸🇦' },
  { code: 'SE', dial: '+46',  label: 'Sweden',         flag: '🇸🇪' },
  { code: 'SG', dial: '+65',  label: 'Singapore',      flag: '🇸🇬' },
  { code: 'TH', dial: '+66',  label: 'Thailand',       flag: '🇹🇭' },
  { code: 'TR', dial: '+90',  label: 'Turkey',         flag: '🇹🇷' },
  { code: 'TW', dial: '+886', label: 'Taiwan',         flag: '🇹🇼' },
  { code: 'UA', dial: '+380', label: 'Ukraine',        flag: '🇺🇦' },
  { code: 'AE', dial: '+971', label: 'UAE',            flag: '🇦🇪' },
  { code: 'VN', dial: '+84',  label: 'Vietnam',        flag: '🇻🇳' },
  { code: 'ZA', dial: '+27',  label: 'South Africa',   flag: '🇿🇦' },
];

const DEFAULT_COUNTRY = COUNTRY_DIAL_CODES[0]; // US

/**
 * Detect the user's most-likely country from browser locale.
 *
 * Order of attempts (most to least specific):
 *   1. Intl.Locale().region — modern browsers expose region from `navigator.language`
 *   2. Parse the region suffix manually from `en-PH`, `fr-CA`, etc.
 *   3. Fallback to first-language hint via `navigator.languages`
 *   4. Default to US.
 */
export const detectDefaultCountry = () => {
  if (typeof navigator === 'undefined') return DEFAULT_COUNTRY;

  const candidates = [navigator.language, ...(navigator.languages || [])].filter(Boolean);

  for (const tag of candidates) {
    // Try the modern API
    try {
      // eslint-disable-next-line no-undef
      const region = new Intl.Locale(tag).region;
      if (region) {
        const hit = COUNTRY_DIAL_CODES.find((c) => c.code === region.toUpperCase());
        if (hit) return hit;
      }
    } catch {
      /* Older browsers — fall through to regex parse */
    }
    // Manual parse: "en-PH" → "PH"
    const m = /-([A-Z]{2})$/i.exec(tag);
    if (m) {
      const code = m[1].toUpperCase();
      const hit = COUNTRY_DIAL_CODES.find((c) => c.code === code);
      if (hit) return hit;
    }
  }
  return DEFAULT_COUNTRY;
};
